module.exports = __webpack_public_path__ + "img/info3V2H5.ba28a8f1.png";